import React from 'react';

import { useIntl } from 'react-intl-next';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/new';
import Form from '@atlaskit/form';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';

import { messages as commonMessages } from '../../../common/messages';
import { Bold } from '../../../common/ui/bold/styled';
import { useStore as useScheduleStore } from '../../../controllers/schedule-store';
import { useCurrentUser } from '../../../utils/hooks/current-user';

import { messages } from './messages';
import { type TakeOnCallProps } from './types';

const TakeOnCall: React.FC<TakeOnCallProps> = ({ onClose }) => {
	const intlApi = useIntl();
	const [{ takeOnCallLoading }, { takeOnCallAction }] = useScheduleStore();
	const current = useCurrentUser();

	return (
		<Form
			onSubmit={() => {
				takeOnCallAction({ accountId: current.user!.atlassianIdentifier });
			}}
		>
			{({ formProps }) => (
				<form {...formProps}>
					<ModalHeader>
						<ModalTitle>{intlApi.formatMessage(messages.title)}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						{intlApi.formatMessage(messages.explanation, {
							bold: (str: React.ReactNode) => <Bold>{str}</Bold>,
						})}
					</ModalBody>
					<ModalFooter>
						<ButtonGroup>
							<Button appearance="subtle" onClick={onClose}>
								{intlApi.formatMessage(commonMessages.cancel)}
							</Button>
							<Button autoFocus appearance="primary" isLoading={takeOnCallLoading} type="submit">
								{intlApi.formatMessage(commonMessages.overrideButton)}
							</Button>
						</ButtonGroup>
					</ModalFooter>
				</form>
			)}
		</Form>
	);
};

export { TakeOnCall };
